import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import EndUserForm from '../components/EndUserForm';
import * as endUserActions from '../redux/modules/endUsers';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  createEndUser: PropTypes.func,
  t: PropTypes.func,
};

const defaultProps = {};

class EndUserCreate extends React.Component {
  createUser = (values) => {
    values.role = 'USER';
    this.props.createEndUser(values);
  };

  render() {
    return (
      <PageBase title={this.props.t('create_new_user')}>
        <EndUserForm onSubmit={this.createUser} isModify={false} />
      </PageBase>
    );
  }
}

EndUserCreate.defaultProps = defaultProps;
EndUserCreate.propTypes = propTypes;

const extended = translate(['translations'], { i18n })(EndUserCreate);
export default connect(null, endUserActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/EndUserCreate.js